class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        writeLogsEnabled: false,
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: true,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

export { ExtendError, verifyExtend, getConfiguration};